import styled from 'styled-components'

export const Title = styled.h1`
    margin: 0;
    padding: 0;

    color: ${ props => props.theme.colors[props.color] };
    font-size: 4em;

    font-family: "Doto", serif;
    font-optical-sizing: auto;
    font-weight: <weight>;
    font-style: normal;
    font-variation-settings: "ROND" 0;

    @media print {
        font-size: 2.5em;
        line-height: 1;
        letter-spacing: 0.03em;
    }

    ${ props => props.s }
`

export const Subtitle = styled.h2`
    color: ${ props => props.theme.colors[props.color] };

    font-family: "Doto", serif;
    font-optical-sizing: auto;
    font-weight: ${ props => props.bold ? '900' : 'normal' };
    font-size: ${ props => props.size || 'normal' };
    font-variation-settings: "ROND" 0;

    @media print {
        line-height: 1.15;
        font-size: ${ props => props.size || '1.2em' };
    }

    ${ props => props.s }
`
